import { memo } from 'react';

import { Result } from '@steinpilz/react-ux/business-app';

import { useTranslation } from '@steinpilz/react-ux/i10n';

const NotFoundPage = () => {
  const t = useTranslation();

  return <Result title="404" subTitle={t('App.Errors.404')} />;
};

export default memo(NotFoundPage);
